/* eslint-disable max-len */
import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { appUrl } from "../../../constants/url-constants";
import { NoCarImageFoundPath } from "../../shared/no-car-image-found";
import { getCarName } from "../../../utils/helpers/car-properties.ae";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { carDetailUrlAu } from "../../../utils/helpers/get-detail-page-url";

const MetaTagsCarDetailsV2 = ({ carDetails, cityName, config }) => {
    const { mainImage, threeSixtyViewUrl, year, make, model, appointmentId, variant, odometerReading, bodyType, booked, listingActive } = carDetails;
    const { relativeURL } = carDetailUrlAu({ year, carName: `${make || ""} ${model || ""}`, carId: appointmentId });
    const relativeUrlLowercase = relativeURL.toLowerCase();
    const detailsPageUrl = `${appUrl()}${relativeUrlLowercase}`;
    let canonicalUrl = detailsPageUrl;
    if (canonicalUrl[canonicalUrl.length - 1] !== "/") {
        canonicalUrl += "/";
    }

    const hasImage = mainImage && mainImage.path;
    const isView360Enabled = !!threeSixtyViewUrl;
    const imageUrl = hasImage ? fastlyUrl(config.imageHost, mainImage.path,
        isView360Enabled ? imageTypes.gsCarCard360 : imageTypes.gsCarCard) : NoCarImageFoundPath;

    const carName = `${getCarName(carDetails)} ${carDetails.variant}`;
    const isSold = booked || !listingActive;

    return (
        <Helmet>
            <title>{`Used ${carName} ${odometerReading}KM Driven Car in Australia`}</title>
            <meta name="ROBOTS" content={isSold ? "NOINDEX,FOLLOW" : "INDEX,FOLLOW"} />
            <meta name="title" content={`Used ${carName} ${odometerReading} KM Driven Car in Australia`} />
            <meta name="description"
                content={`Upgrade your driving experience with this ${year} ${make} ${model} ${variant} in Australia. With ${odometerReading} KM Driven and impressive features, this ${bodyType} is perfect for work or play.`} />
            <meta name="keywords"
                content={`Buy used ${carName}, buy second hand ${carName}, used ${carName} in ${cityName}, second hand ${carName} from ${cityName}, 2nd hand ${carName} online in ${cityName}, pre-owned ${carName} in ${cityName}`} />
            <meta property="og:title" content={`Used ${carName} in ${cityName} - Second Hand ${carName} in ${cityName} for Sale`} />
            <meta property="og:description"
                content={`Used ${carName} car in ${cityName} for Sale - Cars24 offers 100% verified second hand cars in ${cityName}. Avail old cars at best price along with Easy Finance & RC Transfer.`} />
            <meta property="og:url" content={detailsPageUrl} />
            <link href={canonicalUrl} rel="canonical" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Cars24" />
            { imageUrl && <meta property="og:image" content={imageUrl} /> }
        </Helmet>
    );
};

MetaTagsCarDetailsV2.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    cityName: PropTypes.string.isRequired,
    carDetails: PropTypes.object,
    config: PropTypes.object,
    countryCode: PropTypes.string
};

export default withRouter(MetaTagsCarDetailsV2);
